import { __makeTemplateObject } from '../../../../../../../../node_modules/tslib/tslib.es6.js';
import { Divider } from '@mui/material';
import { styled } from '@mui/system';

var VertDivider = styled(Divider)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border-color: ", ";\n"], ["\n  border-color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.palette.neutral600;
});
var templateObject_1;

export { VertDivider };
